export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.4ca3611e.worker.js");
}
